// Assets/product-form.js
(() => {
  class ProductFormShim extends HTMLElement {
    connectedCallback() {
      // Try to find the actual form element
      this.form = this.querySelector('form') || this.closest('form');
      if (!this.form) return;

      // When variant id input changes, keep the URL in sync (?variant=ID)
      const idInput = this.form.querySelector('input[name="id"]');
      if (!idInput) return;

      const updateURL = (variantId) => {
        try {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variantId);
          window.history.replaceState({}, '', url.toString());
        } catch (e) {}
      };

      const observer = new MutationObserver(() => updateURL(idInput.value));
      observer.observe(idInput, { attributes: true, attributeFilter: ['value'] });
      this._observer = observer;

      // Fall back: update on change too
      this.form.addEventListener('change', () => updateURL(idInput.value));
    }
    disconnectedCallback() { this._observer && this._observer.disconnect(); }
  }
  if (!customElements.get('product-form')) {
    customElements.define('product-form', ProductFormShim);
  }
})();